var _rect, _path, _rect2, _rect3, _rect4, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 184.848,
    height: 41.65,
    viewBox: "0 0 184.848 41.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 6.653,
    height: 13.855,
    transform: "translate(94.409 20.804)",
    fill: "#86bc26"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1",
    "data-name": "Trac\\xE9 1",
    d: "M200.982,211.249h-4.6a9.64,9.64,0,0,0-9.631,9.631v17H193.4v-17a2.965,2.965,0,0,1,2.956-2.957h4.6a2.953,2.953,0,0,1,2.957,2.957v17h6.653v-17a9.578,9.578,0,0,0-9.589-9.631",
    transform: "translate(-57.594 -203.35)",
    fill: "#86bc26"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 6.653,
    height: 26.866,
    transform: "translate(117.705 7.899)",
    fill: "#86bc26"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 6.674,
    height: 26.591,
    transform: "translate(71.134 7.899)",
    fill: "#86bc26"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 6.653,
    height: 26.316,
    transform: "translate(31.807 7.899)",
    fill: "#86bc26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2",
    "data-name": "Trac\\xE9 2",
    d: "M161.972,211.249H148.687a9.641,9.641,0,0,0-9.631,9.631v17h6.674v-17a2.966,2.966,0,0,1,2.957-2.957h13.285a2.966,2.966,0,0,1,2.957,2.957v17h6.653v-17a9.6,9.6,0,0,0-9.61-9.631",
    transform: "translate(-57.594 -203.35)",
    fill: "#86bc26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3",
    "data-name": "Trac\\xE9 3",
    d: "M124.631,211.249h-7.9l-4.33,6.8-4.351-6.8h-7.9l8.3,13.01-8.7,13.623h7.9l4.752-7.434,4.731,7.434h7.9l-8.681-13.623Z",
    transform: "translate(-57.594 -203.35)",
    fill: "#86bc26"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4",
    "data-name": "Trac\\xE9 4",
    d: "M76.1,211.249h-18.5v9.779h7.012V217.9H76.074a2.966,2.966,0,0,1,2.957,2.957v.148h6.653v-.127a9.591,9.591,0,0,0-9.589-9.631",
    transform: "translate(-57.594 -203.35)",
    fill: "#86bc26"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5",
    "data-name": "Trac\\xE9 5",
    d: "M79.052,227.47a2.966,2.966,0,0,1-2.957,2.957H64.606v-3.021H57.594v13.159L64.247,245v-7.92H76.074a9.632,9.632,0,0,0,9.61-9.61v-.064H79.031v.064Z",
    transform: "translate(-57.594 -203.35)",
    fill: "#86bc26"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6",
    "data-name": "Trac\\xE9 6",
    d: "M235.409,231.229H225.038a2.966,2.966,0,0,1-2.957-2.957v-.844h-6.653v.844a9.618,9.618,0,0,0,9.61,9.61h17.383V227.428h-7.033v3.8Z",
    transform: "translate(-57.594 -203.35)",
    fill: "#86bc26"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7",
    "data-name": "Trac\\xE9 7",
    d: "M235.768,203.35v7.9h-10.73a9.623,9.623,0,0,0-9.61,9.631v.148h6.653v-.148a2.966,2.966,0,0,1,2.957-2.957h10.371v3.1h7.033V207.785Z",
    transform: "translate(-57.594 -203.35)",
    fill: "#86bc26"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7ee541d40006ad1d1611343a8048e74d.svg";
export { ForwardRef as ReactComponent };